/* ====================================================================
   ALTAIR · Offre réservée au lien  —  moteur générique, deux paliers
   --------------------------------------------------------------------
   Une seule mécanique pour toutes les campagnes « cadeau offert dès
   l'achat d'un produit déclencheur ». Aucun identifiant de produit,
   aucun code, aucun texte n'est écrit ici : tout arrive de la section
   « ALTAIR — Offre réservée au lien ». La campagne suivante se règle
   donc depuis le customizer, sans toucher à ce fichier.

   Pourquoi un cadeau posé d'office au panier : une remise Shopify
   « Achetez X, obtenez Y » ne RAJOUTE jamais Y, elle se contente de
   l'offrir s'il y est déjà. Sans ce script, l'offre ne peut donc rien
   délivrer : personne ne met de son plein gré un article à 89,90 €
   au panier en espérant qu'il tombe à zéro.

   JUSQU'À TROIS PALIERS, et deux façons de les empiler. Le mode vient
   de la section (`cfg.cumul`), il ne se devine pas ici.

   Le palier 3 peut porter DEUX cadeaux (un second emplacement, même
   seuil). Un barreau de l'échelle n'est donc plus un cadeau mais un
   seuil, et c'est le seuil qui décide de ce qui est dû.

   Par REMPLACEMENT (défaut) : un seul cadeau au panier à la fois,
   celui du palier atteint. Les campagnes DUO en vol en dépendent.

   Par ADDITION : les cadeaux de TOUS les paliers atteints sont au
   panier ensemble, et tous leurs codes sont posés ensemble.

   Dans les deux cas la règle est la même, et c'est elle qui compte :
   le panier ne doit jamais porter un cadeau que les codes posés ne
   savent pas offrir, parce qu'un cadeau non couvert est facturé plein
   tarif au client. Le remplacement n'est donc pas cosmétique, il est
   protecteur. Et l'addition n'est possible que parce que
   `/cart/update.js` accepte plusieurs codes séparés par des virgules
   (référence de l'API Cart) et que les remises de la boutique sont
   combinables entre elles. Si l'une des deux conditions tombe, le
   client voit trois cadeaux et n'en reçoit qu'un.

   Le filtrage par lien est fait en amont par le script en ligne de la
   section (il doit s'exécuter avant les scripts `defer`, notamment
   avant le pop-up commercial). Ici on se contente de lire son verdict
   dans window.__altairOffre.
   ==================================================================== */
(function () {
  'use strict';

  var ctx = window.__altairOffre;
  if (!ctx || !ctx.actif) return;
  if (window.__altairOffreBooted) return;
  window.__altairOffreBooted = true;

  var CFG     = ctx.cfg || {};
  var KEY     = ctx.key;
  /* Les codes arrivent déjà déchiffrés par la porte de la section : ne
     jamais les relire depuis cfg, qui ne contient que la forme encodée. */
  var CODE    = String(ctx.code  || '').toUpperCase();
  var CODE2   = String(ctx.code2 || '').toUpperCase();
  var CODE3   = String(ctx.code3 || '').toUpperCase();
  var QTE     = Math.max(1, Number(CFG.maxQty) || 1);
  var IDS     = (CFG.triggerIds || []).map(Number);
  var TYPES   = (CFG.triggerTypes || []).map(function (t) { return String(t).trim().toLowerCase(); })
                                        .filter(function (t) { return t.length > 0; });
  var T       = CFG.textes || {};
  var EDITEUR = !!(window.Shopify && window.Shopify.designMode);
  var SUR_PANIER = document.body.classList.contains('template-cart');

  /* Le mode d'empilement, lu et jamais déduit. Une offre sans second
     palier ne cumule rien, quoi que dise le réglage. */
  var CUMUL = !!CFG.cumul;

  /* Les seuils, en nombre de déclencheurs. 0 ou 1 au palier 2 voudrait
     dire « dès le premier déclencheur », ce qui annulerait le premier
     cadeau : on plancher à 2, et le palier 3 à au moins un de plus que
     le palier 2 — deux paliers au même seuil, c'est un seul palier qui
     en chasse un autre indéfiniment. */
  var SEUIL2 = Math.max(2, Number(CFG.palier2Seuil) || 2);
  var SEUIL3 = Math.max(SEUIL2 + 1, Number(CFG.palier3Seuil) || SEUIL2 + 1);

  /* Les cadeaux, décrits de la même façon pour que la suite du fichier
     n'ait plus à savoir lequel est lequel. Chacun porte SON seuil : le
     reste du moteur n'a plus qu'à comparer. */
  var CADEAUX = [
    {
      rang: 1,
      seuil: 1,
      variante: Number(CFG.variantId) || 0,
      produit: Number(CFG.giftProductId) || 0,
      code: CODE,
      image: CFG.image || '',
      prixBarre: CFG.prixBarre || '',
      prixOffert: CFG.prixOffert || ''
    },
    {
      rang: 2,
      seuil: SEUIL2,
      variante: Number(CFG.variantId2) || 0,
      produit: Number(CFG.giftProductId2) || 0,
      code: CODE2 || CODE,
      image: CFG.image2 || CFG.image || '',
      prixBarre: CFG.prixBarre2 || '',
      prixOffert: CFG.prixOffert2 || CFG.prixOffert || ''
    },
    {
      rang: 3,
      seuil: SEUIL3,
      variante: Number(CFG.variantId3) || 0,
      produit: Number(CFG.giftProductId3) || 0,
      code: CODE3 || CODE,
      image: CFG.image3 || CFG.image || '',
      prixBarre: CFG.prixBarre3 || '',
      prixOffert: CFG.prixOffert3 || CFG.prixOffert || ''
    },
    /* Le SECOND cadeau du palier 3. Même SEUIL que le rang 3, donc même
       barreau de l'échelle : « 3 Koffer » donne deux articles, pas un.
       C'est le seul moyen d'exprimer une échelle dont le palier haut
       cumule deux cadeaux SANS cumuler les paliers du dessous. Mesuré
       sur ALTAIR : en addition, le client à 2 valises recevrait aussi
       le cadeau du palier 1, soit 280 € de cadeaux là où l'offre n'en
       promet que 190.
       Il porte le code du palier 3 : c'est ce code qui doit couvrir les
       DEUX articles, sinon le second part facturé plein tarif. Laissé
       vide, `PALIERS` le filtre et l'échelle reste exactement celle
       d'avant. */
    {
      rang: 4,
      seuil: SEUIL3,
      variante: Number(CFG.variantId3b) || 0,
      produit: Number(CFG.giftProductId3b) || 0,
      code: CODE3 || CODE,
      image: CFG.image3b || CFG.image3 || CFG.image || '',
      prixBarre: CFG.prixBarre3b || '',
      prixOffert: CFG.prixOffert3 || CFG.prixOffert || ''
    }
  ];

  /* Un palier sans variante ou sans code ne peut rien délivrer : on le
     retire plutôt que de promettre un cadeau qui restera payant. */
  var PALIERS = CADEAUX.filter(function (c) { return c.variante > 0 && c.code; });

  /* Une offre peut très bien n'avoir AUCUN cadeau : « 40 € sur ta
     commande », « frais de port offerts », un avoir. C'est le cas de la
     moitié des offres encore vivantes dans Klaviyo. Avant, ce fichier
     sortait ici et le client recevait un lien muet : ni rappel de
     l'offre, ni code posé au panier.

     Ce qui change pour lui : le pop-up s'ouvre quand même et dit ce
     qu'il gagne, et le code est réaffirmé au panier. Ce qui ne tourne
     pas : la synchronisation du panier, puisqu'il n'y a aucune ligne à
     poser, à chasser ou à retirer — faire tourner le moteur à vide
     n'aurait produit que des appels réseau et une note vide. */
  var SANS_CADEAU = PALIERS.length === 0;
  if (SANS_CADEAU && !CODE) return;

  /* ---------------------------------------------------------------
     Mémoire de session. Volontairement en sessionStorage : un refus
     du cadeau ne doit pas poursuivre le client pendant des semaines.
     Les marques sont suffixées par l'ARTICLE offert : refuser le sac à
     dos ne doit pas priver le client du sac de voyage au second Koffer.
     Par l'article et non par le rang, parce qu'un même article peut être
     dû à deux paliers : refuser le sac à dos à 1 valise doit valoir
     aussi quand il revient à 3, sinon on le réimpose à quelqu'un qui
     l'avait retiré du panier à la main.
     --------------------------------------------------------------- */
  function lire(k)    { try { return sessionStorage.getItem(KEY + k); } catch (e) { return null; } }
  function ecrire(k)  { try { sessionStorage.setItem(KEY + k, '1');   } catch (e) {} }
  function oublier(k) { try { sessionStorage.removeItem(KEY + k);     } catch (e) {} }

  /* La seule marque qui doit SURVIVRE à la session : le pop-up a déjà
     été montré. Mesuré sur une vraie machine : en sessionStorage, il
     revenait à chaque nouvel onglet, donc en pratique à chaque visite.
     Une fenêtre modale qui se rouvre à chaque passage cesse d'être une
     annonce et devient une nuisance.
     `KEY` contient le code de l'offre, donc une offre suivante porte
     une autre clé et se montre à nouveau — sans qu'on ait à purger
     quoi que ce soit. Repli en session si localStorage est refusé
     (navigation privée, cookies bloqués) : mieux vaut un pop-up de
     trop qu'une fenêtre qui ne s'ouvre jamais. */
  function cleVue() {
    var f = String(CFG.fin || '').replace(/[^0-9A-Za-z]/g, '');
    return KEY + ':popup' + (f ? '@' + f : '');
  }
  function dejaVu()   { try { return localStorage.getItem(cleVue()) === '1'; } catch (e) { return lire(':popup') === '1'; } }
  function noterVu()  { try { localStorage.setItem(cleVue(), '1'); } catch (e) { ecrire(':popup'); } }

  /* --------------------------------------------------------------- */
  function post(url, charge) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(charge)
    }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function panier() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* Renvoie le palier dont relève cette ligne de panier, ou null. */
  function quelCadeau(it) {
    for (var i = 0; i < PALIERS.length; i++) {
      var c = PALIERS[i];
      if (it.variant_id === c.variante) return c;
      if (c.produit > 0 && it.product_id === c.produit) return c;
    }
    return null;
  }

  function estDeclencheur(it) {
    if (quelCadeau(it)) return false;
    if (IDS.indexOf(it.product_id) !== -1) return true;
    return TYPES.indexOf(String(it.product_type || '').toLowerCase()) !== -1;
  }

  /* ---------------------------------------------------------------
     Le code est déjà dans la session (cookie posé par /discount/…),
     mais la navigation peut l'avoir remplacé par un autre, et le
     changement de palier en impose un autre. On ne le réaffirme que
     lorsqu'il change : sans lui, le cadeau reste payant.
     --------------------------------------------------------------- */
  /* Plusieurs codes à la fois : `/cart/update.js` accepte une liste
     séparée par des virgules (référence de l'API Cart). On les trie et
     on dédoublonne avant de comparer, sinon un même jeu de codes posé
     dans un autre ordre repartirait sur le réseau à chaque tour. */
  var codePose = '';
  function poserCodes(codes) {
    var vus = {}, liste = [];
    for (var i = 0; i < (codes || []).length; i++) {
      var c = codes[i];
      if (!c || vus[c]) continue;
      vus[c] = true;
      liste.push(c);
    }
    if (!liste.length) return Promise.resolve();
    var chaine = liste.sort().join(',');
    if (codePose === chaine) return Promise.resolve();
    codePose = chaine;
    return post('/cart/update.js', { discount: chaine });
  }

  /* --------------------------------------------------------------- */
  var etat = null;   // { declencheurs, palier, cadeau, attendu, offert }
  var enCours = false;

  function fin(v) { enCours = false; return v; }

  /* Les paliers DUS pour ce nombre de déclencheurs, du plus bas au plus
     haut. Toujours au moins un : sans déclencheur, on reste sur le
     palier 1, c'est son cadeau qu'on montre au panier, pas encore
     acquis, avec l'invitation à ajouter un Koffer.

     En addition, tous les paliers franchis sont dus. En remplacement,
     seul le plus haut franchi l'est — et c'est bien le mot « dus » qui
     compte, parce que tout cadeau présent au panier et NON dû est un
     article que les codes posés n'offrent pas, donc une ligne qui sera
     facturée. */
  function dus(declencheurs) {
    var atteints = PALIERS.filter(function (c) { return declencheurs >= c.seuil; });
    if (!atteints.length) return [PALIERS[0]];
    if (CUMUL) return atteints;
    /* En remplacement, TOUS les paliers du seuil le plus haut atteint,
       et non le seul dernier de la liste. Deux cadeaux peuvent partager
       un seuil (sac à dos ET sac de voyage à 3 valises) : n'en garder
       qu'un ferait chasser l'autre du panier comme un intrus, et le
       client perdrait sous ses yeux un cadeau qu'on venait de lui
       promettre. Les seuils de `CADEAUX` sont croissants par
       construction, donc le dernier atteint porte bien le seuil le plus
       haut. */
    var dernier = atteints[atteints.length - 1].seuil;
    return atteints.filter(function (c) { return c.seuil === dernier; });
  }

  function codesDe(liste) {
    return liste.map(function (c) { return c.code; });
  }

  /* Le retrait de l'intrus relance un tour complet, et en addition
     chaque cadeau posé en relance un aussi. Un garde-fou, parce qu'un
     `/cart/change.js` qui répondrait 200 sans rien retirer ferait
     tourner le navigateur en rond, écran figé et panier martelé.

     Le budget compte le pire cas honnête : un intrus à chasser, puis
     les trois cadeaux dus à poser un par un, soit quatre écritures. On
     laisse deux tours de marge et pas plus — un budget large ne répare
     rien, il allonge juste le martèlement avant l'abandon. */
  var tours = 0;
  var TOURS_MAX = PALIERS.length + 3;

  /* Relire le panier et en déduire l'état. Aucune écriture ici : c'est
     la seule source de `etat`, et elle vient toujours du panier réel.

     Peindre la note depuis un état d'AVANT la modification affiche un
     cadeau absent, ou l'absence d'un cadeau qu'on vient de poser. Le
     thème le rattrapait par chance, parce que le rafraîchissement du
     tiroir déclenche un second tour ; sur un gabarit sans tiroir, la
     note restait fausse jusqu'au rechargement suivant. */
  function relever() {
    return panier().then(function (c) {
      if (!c) return null;

      var declencheurs = 0;
      /* Indexé par ARTICLE offert, jamais par rang. Deux paliers peuvent
         offrir le même article : le sac à dos est dû à 1 valise, puis de
         nouveau à 3. Indexé par rang, la ligne du panier se rangeait
         sous le PREMIER rang qui la reconnaît, donc sous le rang 1 ; au
         palier 3, le rang 3 paraissait vide et le rang 1 occupé par un
         cadeau non dû. Le moteur chassait alors du panier le cadeau
         qu'il venait de poser, le reposait, le rechassait, et finissait
         sur son budget de tours en laissant le client sans son cadeau.
         Ce qui compte n'a jamais été le rang mais l'article présent au
         panier, puisque c'est lui qui se facture. */
      var presents = {};            // variante offerte -> ligne de panier
      (c.items || []).forEach(function (it) {
        var cad = quelCadeau(it);
        if (cad) { if (!presents[cad.variante]) presents[cad.variante] = it; return; }
        if (estDeclencheur(it)) declencheurs += (it.quantity || 0);
      });

      var attendus = dus(declencheurs);
      /* `attendu` reste le palier le PLUS HAUT dû : c'est celui que la
         note du panier met en avant, et en addition c'est aussi le
         dernier gagné, donc celui que le client vient de débloquer. Les
         autres sont déjà acquis depuis un geste précédent. */
      var attendu = attendus[attendus.length - 1];

      etat = {
        declencheurs: declencheurs,
        palier: attendu.rang,
        cadeau: presents[attendu.variante] || null,
        attendu: attendu,
        attendus: attendus,
        presents: presents,
        offert: declencheurs > 0
      };
      return { presents: presents, attendus: attendus, attendu: attendu };
    });
  }

  /* Relever une dernière fois puis annoncer la modification : l'appelant
     rafraîchira le thème, et la note qu'il peindra sera déjà juste. */
  function conclure(modifie) {
    return relever().then(function () { return fin(modifie); });
  }

  function synchroniser() {
    if (enCours) return Promise.resolve(false);
    if (++tours > TOURS_MAX) return Promise.resolve(false);
    enCours = true;

    return relever().then(function (v) {
      if (!v) return fin(false);

      var attendus = v.attendus;
      /* Sans AUCUN déclencheur au panier, rien n'est dû. `dus()` rend
         quand même le palier 1, et c'est voulu : la note doit pouvoir
         montrer au client ce qui l'attend s'il ajoute une valise. Mais
         AGIR sur cette valeur posait un cadeau à 90 € dans un panier
         vide, sous un code qui exige l'achat d'une valise pour l'offrir,
         donc une ligne facturée plein tarif. Et le client qui retirait
         sa dernière valise gardait son cadeau, devenu payant au passage.
         L'affichage garde son palier 1 (`v.attendu`), le moteur non. */
      if (!etat.offert) attendus = [];
      /* Les ARTICLES dus, pas les rangs : un article présent au panier
         et non couvert par les codes posés est une ligne facturée, quel
         que soit le rang sous lequel on l'avait rangé. */
      var dusParVar = {};
      attendus.forEach(function (c) { dusParVar[c.variante] = true; });

      /* Les codes à poser : ceux de tous les paliers dus. En
         remplacement il n'y en a qu'un, en addition autant que de
         paliers franchis. On les pose à CHAQUE sortie de cette
         fonction, y compris les sorties en échec : un cadeau déjà au
         panier sans son code est une ligne facturée. */
      var codes = codesDe(attendus);
      /* Le code du lien reste réaffirmé même quand rien n'est dû : il
         est déjà dans la session Shopify via le `?discount=` de l'URL,
         et une offre sans cadeau n'a que lui. */
      if (!codes.length) codes = [CODE];

      /* 1 · Chasser tout cadeau NON dû. Le laisser serait le facturer :
         les codes posés n'offrent que les paliers dus. On efface sa
         marque `:pose` pour que le retrait ne soit pas relu plus tard
         comme un refus du client.

         C'est ici que vit la différence entre les deux modes, et elle
         tient en un mot : en remplacement, le cadeau du palier d'en
         dessous n'est plus dû dès qu'on monte, donc il part. En
         addition, il reste dû, donc il reste. Le reste du code est le
         même, ce qui est exactement le but — deux chemins séparés
         auraient fini par diverger sur le seul point qui coûte de
         l'argent. */
      var intrus = null;
      PALIERS.forEach(function (c) {
        if (!dusParVar[c.variante] && v.presents[c.variante]) {
          intrus = { c: c, it: v.presents[c.variante] };
        }
      });

      if (intrus) {
        oublier(':pose' + intrus.c.variante);
        return post('/cart/change.js', { id: intrus.it.key, quantity: 0 })
          .then(function (r) {
            if (!r) return fin(false);
            /* On repasse par un tour complet : le panier a changé, et
               c'est lui qui décide, pas l'état qu'on avait en main. */
            enCours = false;
            return synchroniser().then(function () { return true; });
          });
      }

      /* Rien n'est dû et il ne reste plus d'intrus à chasser : s'arrêter
         ici. Sans cette sortie, la suite tombait dans la branche « le
         cadeau attendu manque » et ajoutait au panier le cadeau du
         palier 1 affiché par la note. */
      if (!attendus.length) return poserCodes(codes).then(function () { return fin(false); });

      /* 2 · Le premier palier dû dont le cadeau MANQUE encore. On n'en
         traite qu'un par tour : chaque ajout change le panier, et c'est
         le panier relu qui décide du suivant, pas l'état qu'on a en
         main. Le budget de tours plus haut garantit qu'on s'arrête.

         Les refus et les échecs sont comptés PAR PALIER : refuser le
         sac à dos ne doit pas priver le client du sac de voyage, et une
         rupture de stock sur l'un ne doit pas annuler les autres. */
      var aPoser = null;
      for (var k = 0; k < attendus.length; k++) {
        var cand = attendus[k];
        if (v.presents[cand.variante]) continue;
        if (lire(':refus' + cand.variante) === '1') continue;
        if (lire(':echec' + cand.variante) === '1') continue;
        /* Posé auparavant et absent aujourd'hui : c'est le client qui
           l'a retiré. On ne le lui réimpose pas pendant cette session. */
        if (lire(':pose' + cand.variante) === '1') { ecrire(':refus' + cand.variante); continue; }
        aPoser = cand;
        break;
      }

      var attendu = v.attendu;
      var ligne = etat.cadeau;

      if (aPoser) {
        attendu = aPoser;
        ligne = null;
      }

      var marque = ':pose'  + attendu.variante;
      var refus  = lire(':refus' + attendu.variante) === '1';
      var echec  = lire(':echec' + attendu.variante) === '1';

      if (refus || echec) return poserCodes(codes).then(function () { return fin(false); });

      if (!ligne) {
        /* _altair_gift : ce cadeau est pose d'office, le client ne l'a pas
           choisi. La propriete dit au pixel Meta de ne pas le compter comme
           un AddToCart. Elle est indispensable ICI et pas seulement utile :
           contrairement aux cadeaux des pop-ups, celui-ci entre au panier a
           son PRIX PLEIN et c'est le code de remise qui le ramene a zero.
           Le filtre par prix nul du pixel ne peut donc pas l'attraper, et
           sans cette marque Meta recevrait un AddToCart a 89,90 EUR pour un
           article que personne n'a demande. Voir snippets/altair-meta-pixel.liquid. */
        return post('/cart/add.js', { items: [{ id: attendu.variante, quantity: QTE, properties: { '_altair_gift': '1' } }] })
          .then(function (r) {
            // Rupture de stock ou variante retirée : on abandonne au lieu
            // de relancer l'ajout à chaque rechargement. Les codes sont
            // posés quand même — les cadeaux des autres paliers sont
            // peut-être déjà au panier, et sans leur code ils se
            // factureraient.
            if (!r) {
              ecrire(':echec' + attendu.variante);
              return poserCodes(codes).then(function () { return fin(false); });
            }
            ecrire(marque);
            return poserCodes(codes).then(function () {
              /* En addition, il peut rester un palier dû dont le cadeau
                 manque encore : on ne pose qu'un article par tour, et
                 c'est le panier relu qui désigne le suivant. Le budget
                 de tours arrête la boucle si le panier ne bouge pas. */
              /* Plusieurs cadeaux dus et un seul posé par tour : il faut
                 repasser. Vrai en addition, vrai aussi en remplacement
                 depuis qu'un palier peut porter deux cadeaux. Tester
                 `CUMUL` ici laissait le second cadeau du palier 3 absent
                 du panier jusqu'au rechargement suivant. */
              if (attendus.length > 1) {
                enCours = false;
                return synchroniser().then(function () { return true; });
              }
              return conclure(true);
            });
          });
      }

      ecrire(marque);

      // Un seul cadeau par commande : la quantité est figée, elle ne
      // suit pas le nombre de déclencheurs.
      if (ligne.quantity !== QTE) {
        return post('/cart/change.js', { id: ligne.key, quantity: QTE })
          .then(function (r) {
            if (!r) return fin(false);
            return poserCodes(codes).then(function () { return conclure(true); });
          });
      }

      return poserCodes(codes).then(function (r) { return fin(!!r); });
    }).catch(function () { return fin(false); });
  }

  /* ---------------------------------------------------------------
     Le rappel dans le panier (tiroir et page /cart)
     --------------------------------------------------------------- */
  /* Où la note s'accroche. Le tiroir du thème s'appelle désormais
     `#AltairCartDrawer` et sa liste de lignes porte `data-altair-cart-items`
     (`snippets/altair-cart-drawer.liquid`). L'ancien `[data-lume-cart-items]`
     n'existe plus nulle part : mesuré à zéro occurrence dans le thème ET sur
     la page réelle. Le rappel de l'offre était donc invisible au panier pour
     TOUS les clients depuis le remplacement du tiroir, alors que c'est la
     seule surface du dispositif qui travaille à faire monter le panier.
     Le sélecteur n'est pas préfixé par l'id du tiroir : la page /cart rend
     la même liste sans ce conteneur. */
  var ANCRES = [
    '[data-altair-cart-items]',            // tiroir du thème, et page /cart
    '#main-cart-items .wt-cart__body',     // ancien gabarit /cart
    '#main-cart-items .js-contents'        // ancien gabarit /cart, panier vide
  ];

  function echappe(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function vignette(src) {
    return src
      ? '<span class="altair-offre-note__media"><img src="' + echappe(src) +
        '" alt="" width="160" height="160" loading="lazy" decoding="async"></span>'
      : '';
  }

  /* `avenir` : le cadeau n'est pas encore acquis. Sans ce mot, la ligne
     de relance affiche « 189,90 € 0,00 € » exactement comme la ligne du
     cadeau acquis juste au-dessus, et annonce gratuit un objet qui ne
     l'est pas encore. Une promesse présentée comme un fait. */
  function prix(cad, avenir) {
    return '<span class="altair-offre-note__prix">' +
      (cad.prixBarre ? '<s>' + echappe(cad.prixBarre) + '</s>' : '') +
      (avenir ? '<i>' + echappe(avenir) + '</i>' : '') +
      '<b>' + echappe(cad.prixOffert) + '</b>' +
    '</span>';
  }

  var COCHE = '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">' +
    '<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" ' +
    'stroke-linejoin="round" d="M2.5 8.5l3.5 3.5 7.5-8"/></svg>';

  /* La relance vers le second palier. C'est la seule ligne de tout le
     dispositif qui travaille à faire monter le panier : elle ne s'affiche
     que là où elle est vraie, un déclencheur acquis et le seuil pas
     encore atteint. */
  /* `{n}` = ce qu'il reste à ajouter. Le marchand écrit le texte, pas
     le nombre : sinon un seuil déplacé de 2 à 3 ferait mentir la note
     sans que personne ne s'en aperçoive. */
  function comble(texte, n) {
    return String(texte == null ? '' : texte).split('{n}').join(String(n));
  }

  /* Le palier juste AU-DESSUS de ceux déjà dus. Codé en dur sur le
     rang 2 jusqu'ici, ce qui suffisait à deux paliers et faisait
     disparaître la relance au client qui a deux Koffer sur une échelle
     de trois : au moment précis où il est à un pas du plus gros
     cadeau, la note ne lui disait plus rien. */
  function suivant() {
    /* Comparé sur le SEUIL et non sur le rang : deux cadeaux au même
       seuil sont le même barreau, et inviter le client à monter vers un
       palier qu'il a déjà atteint est une relance fausse. */
    var haut = etat && etat.attendu ? etat.attendu.seuil : 1;
    for (var i = 0; i < PALIERS.length; i++) {
      if (PALIERS[i].seuil > haut) return PALIERS[i];
    }
    return null;
  }

  function relance(manquants) {
    var deux = suivant();
    if (!deux || !T.relanceTitre) return '';
    return '<span class="altair-offre-note__up">' +
      vignette(deux.image) +
      '<span class="altair-offre-note__texte">' +
        '<span class="altair-offre-note__sur">' + echappe(comble(T.relanceSur, manquants)) + '</span>' +
        '<span class="altair-offre-note__titre">' + echappe(comble(T.relanceTitre, manquants)) + '</span>' +
        prix(deux, T.relancePrix || '') +
      '</span>' +
    '</span>';
  }

  /* L'échelle entière, dans le panier. Le client qui ne voit que le
     cadeau acquis et le palier juste au-dessus ne sait pas ce que vaut
     la montée complète : c'est pourtant ce qui décide d'un deuxième et
     d'un troisième Koffer. Les trois barreaux sont donc affichés
     ensemble, avec ce qui est gagné, ce qui vient, et ce qu'il reste à
     ajouter pour l'atteindre.

     Le gabarit n'est pas écrit ici. La section le rend une seule fois
     dans un `template` et on le clone : le marchand règle ses libellés,
     ses noms de cadeaux et ses prix en un seul endroit, et le pop-up et
     le panier ne peuvent pas se contredire. Une seconde copie du
     balisage dans ce fichier aurait divergé au premier changement de
     campagne, et la divergence se serait vue chez le client. */
  function echelleNote() {
    if (PALIERS.length < 2) return '';      // une offre à un cadeau n'a pas d'échelle
    var tpl = document.querySelector('template[data-altair-offre-echelle]');
    if (!tpl || !tpl.content) return '';

    var hote = document.createElement('div');
    hote.appendChild(tpl.content.cloneNode(true));
    var liste = hote.querySelector('[data-altair-offre-echelle-liste]');
    if (!liste) return '';
    liste.className += ' altair-offre-note__echelle';
    /* Hors cumul, chaque cadeau affiche sur un barreau est un cadeau
       reellement remis a ce palier : on les montre tous. */
    if (!CUMUL) liste.className += ' altair-offre-note__echelle--tous';

    var decl = (etat && etat.declencheurs) || 0;
    var pas = liste.querySelectorAll('[data-rang]');
    var suivantMarque = false;
    for (var i = 0; i < pas.length; i++) {
      var li = pas[i];
      var seuil = Number(li.getAttribute('data-seuil')) || 0;
      if (decl >= seuil) { li.className += ' is-acquis'; continue; }

      /* Le mot de conditionnel sur les barreaux pas encore gagnés. Sans
         lui, « 89,90 € 0,00 € » se lit exactement comme la ligne du
         cadeau acquis juste au-dessus, et l'échelle annonce gratuit un
         objet qui demande encore un Koffer : une promesse présentée
         comme un fait. Mesuré à l'image avant correction, les trois
         barreaux étaient indiscernables au prix près.
         Le mot vient du marchand (`relance_prix`), il n'est pas inventé
         ici : une offre qui n'en règle aucun n'en affiche aucun.

         Sur TOUS les prix du barreau, pas seulement le premier : les
         paliers s'additionnent, donc un barreau en porte autant que de
         cadeaux cumulés. Le tiroir n'en montre qu'un (le dernier, les
         autres sont masqués en CSS), et c'est précisément celui que la
         première version laissait sans son conditionnel. */
      if (T.relancePrix) {
        var prixs = li.querySelectorAll('.altair-offre-pop__gainprix');
        for (var p = 0; p < prixs.length; p++) {
          var gratuit = prixs[p].querySelector('b');
          if (!gratuit) continue;
          var cond = document.createElement('i');
          cond.textContent = T.relancePrix;
          prixs[p].insertBefore(cond, gratuit);
        }
      }

      /* Un seul barreau porte la relance : celui juste au-dessus. Trois
         « Noch n Koffer » empilés ne poussent à rien, ils se lisent
         comme une liste de conditions. */
      if (!suivantMarque) {
        li.className += ' is-suivant';
        li.setAttribute('data-manque', comble(T.relanceSur, seuil - decl));
        suivantMarque = true;
      } else {
        li.className += ' is-avenir';
      }
    }
    return hote.innerHTML;
  }

  /* La note en mode échelle : un en-tête qui dit où en est le client,
     puis les trois barreaux. Elle remplace le couple « cadeau acquis +
     relance » parce qu'elle dit la même chose en moins de place, et une
     chose de plus : le palier du haut, que la relance cachait. */
  function corpsEchelle(cle) {
    var ech = echelleNote();
    if (!ech) return '';
    var cad = etat.attendu;
    var manque = cle === 'manque';
    var sur   = manque ? T.noteSur   : (cad.rang > 1 ? (T.ok2Sur   || T.okSur)   : T.okSur);
    var titre = manque ? T.noteTitre : (cad.rang > 1 ? (T.ok2Titre || T.okTitre) : T.okTitre);

    return '<span class="altair-offre-note__tete">' +
      '<span class="altair-offre-note__sur' + (manque ? '' : ' altair-offre-note__sur--ok') + '">' +
        (manque ? '' : COCHE) + echappe(sur) +
      '</span>' +
      '<span class="altair-offre-note__titre">' + echappe(titre) + '</span>' +
      (manque && CFG.cibleUrl
        ? '<a class="altair-offre-note__cta" href="' + echappe(CFG.cibleUrl) + '">' +
          echappe(T.noteBouton) + '</a>'
        : '') +
    '</span>' + ech;
  }

  function corps(cle) {
    var cad = etat.attendu;

    if (cle === 'manque') {
      return vignette(cad.image) +
        '<span class="altair-offre-note__texte">' +
          '<span class="altair-offre-note__sur">' + echappe(T.noteSur) + '</span>' +
          '<span class="altair-offre-note__titre">' + echappe(T.noteTitre) + '</span>' +
          prix(cad) +
          (CFG.cibleUrl
            ? '<a class="altair-offre-note__cta" href="' + echappe(CFG.cibleUrl) + '">' +
              echappe(T.noteBouton) + '</a>'
            : '') +
        '</span>';
    }

    /* Les textes « ok2 » valent pour TOUT palier au-dessus du premier,
       pas pour le rang 2 seulement : sur une échelle de trois, le
       client qui débloquait le cadeau le plus haut relisait le texte du
       palier 1 et croyait avoir gagné l'étui. */
    var sur   = cad.rang > 1 ? (T.ok2Sur   || T.okSur)   : T.okSur;
    var titre = cad.rang > 1 ? (T.ok2Titre || T.okTitre) : T.okTitre;

    var acquis = vignette(cad.image) +
      '<span class="altair-offre-note__texte">' +
        '<span class="altair-offre-note__sur altair-offre-note__sur--ok">' + COCHE + echappe(sur) + '</span>' +
        '<span class="altair-offre-note__titre">' + echappe(titre) + '</span>' +
        prix(cad) +
      '</span>';

    if (cle === 'ok-relance') {
      var haut = suivant();
      /* Ce qu'il reste à ajouter se compte sur le seuil du palier
         SUIVANT, pas sur celui du palier 2 : à deux Koffer sur une
         échelle de trois, la note annonçait « encore 0 » parce qu'elle
         soustrayait toujours le seuil du palier 2. */
      return '<span class="altair-offre-note__rang">' + acquis + '</span>' +
             relance(Math.max(1, (haut ? haut.seuil : SEUIL2) - etat.declencheurs));
    }
    return acquis;
  }

  /* Trois états visibles, et un quatrième invisible quand le client a
     refusé le cadeau : la note disparaît plutôt que de le harceler. */
  function etatNote() {
    if (!etat || !etat.cadeau) return 'rien';
    if (!etat.offert) return 'manque';
    /* La relance vaut dès qu'il RESTE un palier au-dessus, quel que
       soit celui qu'on a atteint. La condition d'avant exigeait d'être
       encore au palier 1, donc l'échelle s'arrêtait de parler à mi-
       hauteur. */
    if (suivant()) return 'ok-relance';
    return 'ok';
  }

  function rappel() {
    var cle = etatNote();
    var montrer = cle !== 'rien';
    var html = montrer ? corpsEchelle(cle) : '';
    var echelle = !!html;
    if (montrer && !echelle) html = corps(cle);

    /* La signature de ce qui est PEINT, pas seulement de l'état. En mode
       échelle, passer de un à deux Koffer ne change pas la clé d'état
       (`ok-relance` dans les deux cas) mais change les barreaux acquis
       et la relance : comparer la seule clé gelait la note au premier
       barreau, et le client voyait « Noch 1 Koffer » après avoir mis le
       deuxième. On garde `data-etat` tel quel, deux contrôles le lisent. */
    var signe = cle + '|' + ((etat && etat.declencheurs) || 0) +
      '|' + ((etat && etat.attendu) ? etat.attendu.rang : 0);

    ANCRES.forEach(function (sel) {
      var hotes = document.querySelectorAll(sel);
      for (var i = 0; i < hotes.length; i++) {
        var hote = hotes[i];
        var n = hote.querySelector('[data-altair-offre-note]');

        if (!montrer) { if (n) n.parentNode.removeChild(n); continue; }

        if (!n) {
          n = document.createElement('div');
          n.setAttribute('data-altair-offre-note', '');
          hote.insertBefore(n, hote.firstChild);
        } else if (n.getAttribute('data-signe') === signe) {
          continue;                       // rien n'a changé : pas de réécriture
        }
        n.setAttribute('data-etat', cle);
        n.setAttribute('data-signe', signe);
        n.className = 'altair-offre-note' +
          (cle === 'manque' ? '' : ' is-ok') +
          (echelle ? ' has-echelle' : (cle === 'ok-relance' ? ' has-up' : ''));
        n.innerHTML = html;
      }
    });
  }

  /* ---------------------------------------------------------------
     Le pop-up d'arrivée
     --------------------------------------------------------------- */
  var popup = null, overflowAvant = '', dernierFocus = null;

  function ouvrir() {
    if (!popup || !popup.hidden) return;
    dernierFocus = document.activeElement;
    popup.hidden = false;
    overflowAvant = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    var carte = popup.querySelector('.altair-offre-pop__carte');
    if (carte) carte.focus();
  }

  function fermer() {
    if (!popup || popup.hidden) return;
    popup.hidden = true;
    document.documentElement.style.overflow = overflowAvant;
    if (dernierFocus && dernierFocus.focus) dernierFocus.focus();
  }

  function brancherPopup() {
    popup = document.querySelector('[data-altair-offre-popup]');
    if (!popup) return;

    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-altair-offre-close]')) { e.preventDefault(); fermer(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') fermer();
    });

    if (EDITEUR) {
      // Dans le customizer, le pop-up suit la sélection de la section :
      // sinon le marchand ne peut pas voir ce qu'il règle.
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target && e.target.contains(popup)) ouvrir();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target && e.target.contains(popup)) fermer();
      });
      return;
    }

    if (!CFG.popupActif) return;
    if (SUR_PANIER) return;                 // au panier, le rappel suffit
    if (dejaVu()) return;                   // une fois par offre, pas par session
    setTimeout(function () { noterVu(); ouvrir(); },
               Math.max(0, Number(CFG.popupDelai) || 0) * 1000);
  }

  /* ---------------------------------------------------------------
     Après une modification du panier, les prix affichés sont faux :
     il faut laisser le thème se re-rendre.
     --------------------------------------------------------------- */
  function rafraichir(modifie) {
    if (!modifie) { rappel(); return; }
    if (SUR_PANIER) { window.location.reload(); return; }
    /* L'API publique du tiroir du thème. `window.LumeCart` n'existe plus :
       après chaque écriture au panier, les prix affichés restaient ceux
       d'avant jusqu'au geste suivant du client. */
    if (window.AltairDrawer && typeof window.AltairDrawer.refresh === 'function') {
      nousRafraichissons = Date.now();
      try { window.AltairDrawer.refresh(); } catch (e) {}
    }
    rappel();
  }

  /* Le tiroir émet `altair-cart:refreshed` y compris quand c'est NOUS qui
     l'avons demandé. Sans cette marque, notre propre rafraîchissement
     passerait pour un geste du client et remettrait le budget de tours à
     zéro : un panier qui refuse une écriture (cadeau en rupture) serait
     alors martelé sans fin, écran figé. On ne coupe pas l'écouteur, on
     refuse seulement de recréditer le budget. */
  var nousRafraichissons = 0;

  var minuteur = null;
  function planifier() {
    clearTimeout(minuteur);
    var nous = Date.now() - nousRafraichissons < 1200;
    minuteur = setTimeout(function () {
      if (!nous) tours = 0;                 // nouveau geste du client, nouveau budget
      synchroniser().then(function (modifie) {
        if (modifie) rafraichir(true); else rappel();
      });
    }, 350);
  }

  function demarrer() {
    brancherPopup();
    if (EDITEUR) return;

    /* Offre en argent : on réaffirme le code et on s'arrête là. Shopify
       l'a déjà posé via le `?discount=` de l'URL ; ce second passage
       couvre le cas où une navigation l'a remplacé entre-temps. */
    if (SANS_CADEAU) { poserCodes([CODE]); return; }

    synchroniser().then(rafraichir);

    /* Les deux événements du tiroir du thème. Ils ne sont pas un confort :
       `renderDrawer()` remplace tout le contenu de `#AltairCartDrawer` par
       un rendu frais, donc la note est effacée à CHAQUE changement de
       quantité, ajout d'upsell ou saisie de code promo. Sans repeinture sur
       cet événement, le rappel de l'offre disparaît au premier geste.
       Les anciens noms `lume-cart:*` n'étaient plus émis par personne. */
    document.addEventListener('altair-cart:refreshed', planifier);
    document.addEventListener('altair-cart:opened', planifier);

    var hote = document.getElementById('main-cart-items');
    if (hote) {
      try {
        new MutationObserver(planifier).observe(hote, { childList: true, subtree: true });
      } catch (e) {}
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
